module.exports = __webpack_public_path__ + "3e4122739ec8fb762f783b124125b25f.svg";